export default "__VITE_ASSET__61af835a__$_?component__"